module.exports = "<dynamic-html-outlet [src]=\"data\"></dynamic-html-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dynamic-page/dynamic-page.component.html
// module id = 555
// module chunks = 0